import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
export var getOrdersOptions = function getOrdersOptions(orders) {
  return orders.filter(function (item) {
    return item.label;
  }).map(function (order) {
    return {
      id: "-".concat(order.slug),
      label: order.label,
      counter: null,
      hint: order.hint
    };
  });
};
export var getBroadOptions = function getBroadOptions() {
  return ['Renta Variable ', 'Renta Fija', 'Mixtos', 'Materias Primas', 'Gestion Alternativa', 'Monetario', 'Convertibles'].map(function (label) {
    return {
      id: label,
      label: label
    };
  });
};